var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCooperOffersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 0.443748C19.008 0.313185 19.1607 0.209462 19.3293 0.138653C19.4978 0.0678443 19.6788 0.0313721 19.8616 0.0313721C20.0444 0.0313721 20.2254 0.0678443 20.3939 0.138653C20.5625 0.209462 20.7152 0.313185 20.8432 0.443748C21.3794 0.985623 21.3869 1.86125 20.8619 2.4125L9.77502 15.5188C9.64915 15.657 9.4964 15.7681 9.32611 15.8452C9.15582 15.9224 8.97158 15.964 8.78466 15.9675C8.59774 15.971 8.41207 15.9364 8.23901 15.8656C8.06594 15.7949 7.90913 15.6897 7.77815 15.5563L1.0319 8.72C0.771719 8.45466 0.625977 8.09787 0.625977 7.72625C0.625977 7.35463 0.771719 6.99784 1.0319 6.7325C1.15986 6.60194 1.31258 6.49821 1.48113 6.4274C1.64967 6.3566 1.83065 6.32012 2.01346 6.32012C2.19628 6.32012 2.37725 6.3566 2.5458 6.4274C2.71434 6.49821 2.86706 6.60194 2.99502 6.7325L8.71752 12.5319L18.8425 0.484998C18.8542 0.470508 18.8667 0.456733 18.88 0.443748Z",
    fill: "#02E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperOffersIcon);
export default __webpack_public_path__ + "static/media/cooper-offers_icon.558707cfc999959ac8a350f040d2d341.svg";
export { ForwardRef as ReactComponent };